export const DomainProduct = {
  ANYCHAT: 'ANYCHAT',
  ANYLOGI: 'ANYLOGI',
  ANYX: 'ANYX',
} as const;
export type DomainProduct = (typeof DomainProduct)[keyof typeof DomainProduct];
